import React, { useEffect, useState } from 'react';
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Card,
  CardContent,
  CircularProgress,
} from '@mui/material';

function AuditDataListfromApi({ endpoint = "", headerText = "Audit Data Report", TableHeader = "" }) {
  const [tables, setTables] = useState([]);
  const [pageLoader, setPageLoader] = useState(false);

  useEffect(() => {
    setPageLoader(true);
    fetch(`https://www.rib.sriyansh.co.in${endpoint}`)
      .then((response) => response.json())
      .then((data) => {
        if (Array.isArray(data)) {
          setTables(data);
        } else {
          console.error('Unexpected data format:', data);
        }
        setPageLoader(false);
      })
      .catch((error) => {
        console.error('Error fetching data:', error);
        setPageLoader(false);
      });
  }, [endpoint]);

  const renderTable = (table, index) => {
    if (!Array.isArray(table) || table.length === 0) return null;

    const firstObject = table[0];
    if (!firstObject || typeof firstObject !== 'object') return null;

    const heading = `${index + 1}`;

    return (
      <Card key={index} sx={{ mb: 2, width: '100%' }}>
        <Box
          className="input-groupHeading"
          sx={{
            backgroundColor: '#42a1ad',
            color:"white",
            p: 2,
            borderBottom: '1px solid #ccc',
            fontWeight: 'bold',
          }}
        >
          {TableHeader} Report Number {heading}
        </Box>
        <CardContent>
          <TableContainer component={Paper} sx={{ overflowX: 'auto', maxWidth: '100%' }}>
            <Table>
              <TableHead>
                <TableRow>
                  {Object.keys(firstObject).map((key) => (
                    <TableCell
                      key={key}
                      align="left"
                      sx={{
                        backgroundColor: 'black',
                        color: 'white',
                        fontWeight: 'bold',
                        fontSize: '16px',
                        wordWrap: 'break-word',
                        whiteSpace: 'normal',
                        maxWidth: '150px',
                      }}
                    >
                      {key}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {table.map((row, rowIndex) => (
                  <TableRow key={rowIndex}>
                    {Object.values(row).map((value, colIndex) => (
                      <TableCell
                        key={colIndex}
                        align="left"
                        sx={{ wordWrap: 'break-word', whiteSpace: 'normal' }}
                      >
                        {value || '-'}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    );
  };

  return (
    <Box
      sx={{
        p: { xs: 1, sm: 2 },
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <Card sx={{ width: '100%', p: { xs: 1, sm: 2 } }}>
        <Typography
          variant="h5"
          component="div"
          sx={{
            mb: 2,
            fontWeight: 'bold',
            fontSize: { xs: '1.2rem', sm: '1.5rem' },
          }}
        >
          {headerText}
        </Typography>
        {pageLoader ? (
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              minHeight: '200px',
            }}
          >
            <CircularProgress />
          </Box>
        ) : (
          <Box sx={{ width: '100%' }}>
            {tables.map((table, index) => renderTable(table, index))}
          </Box>
        )}
      </Card>
    </Box>
  );
}

export default AuditDataListfromApi;
